import { ReactNode } from 'react';

export interface IFadeInAnimatedViewProps {
  children: ReactNode;
  isVisible?: boolean;
}
